import React from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import objectPath from "object-path";
import * as builder from "../../../ducks/builder";
import { toAbsoluteUrl } from "../../..";
import KTMenu from "../../../_assets/js/menu";
import KTOffcanvas from "../../../_assets/js/offcanvas";
import { serverurl } from "../../../../app/router/config";

import { Alert } from '@mui/material';
import api from "../../../../app/router/axiosConfig";

// ✅ Custom withRouter HOC for React Router v6
function withRouter(Component) {
  return function WrapperComponent(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params}
      />
    );
  };
}

const offcanvasOptions = {
  overlay: true,
  baseClass: "kt-header-menu-wrapper",
  closeBy: "kt_header_menu_mobile_close_btn",
  toggleBy: {
    target: "kt_header_mobile_toggler",
    state: "kt-header-mobile__toolbar-toggler--active",
  },
};

class HMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companyname: "",
      subscriptionmsg: "",
    };
  }

  offCanvasCommonRef = React.createRef();
  ktMenuCommonRef = React.createRef();

  getHeaderLogo() {
    let result = "logo-light.png";
    if (this.props.headerSelfSkin && this.props.headerSelfSkin !== "dark") {
      result = "logo-dark.png";
    }
    return toAbsoluteUrl(`/media/logos/${result}`);
  }

  get currentUrl() {
    return this.props.location.pathname.split(/[?#]/)[0];
  }

  componentDidMount() {
    this.initOffCanvas();
    this.initKTMenu();
    api.get(serverurl + "getLoggedUserprofile").then((res) => {
      this.setState({ companyname: res.data[0] });
    });
    api.get(serverurl + "getSubscriptionExpiryMsg").then((res) => {
      this.setState({ subscriptionmsg: res.data });
    });
  }

  initOffCanvas = () => {
    // eslint-disable-next-line no-undef
    new KTOffcanvas(this.offCanvasCommonRef.current, offcanvasOptions);
  };

  initKTMenu = () => {
    let menuOptions = {
      submenu: {
        desktop: "dropdown",
        tablet: "accordion",
        mobile: "accordion",
      },
      accordion: {
        slideSpeed: 200,
        expandAll: false,
      },
      dropdown: {
        timeout: 50,
      },
    };

    let menuDesktopMode = "accordion";
    if (
      this.ktMenuCommonRef.current.getAttribute("data-ktmenu-dropdown") === "1"
    ) {
      menuDesktopMode = "dropdown";
    }

    if (typeof objectPath.get(menuOptions, "submenu.desktop") === "object") {
      menuOptions.submenu.desktop = {
        default: menuDesktopMode,
      };
    }

    // eslint-disable-next-line no-undef
    new KTMenu(this.ktMenuCommonRef.current, menuOptions);
  };

  render() {
    const {
      disabledAsideSelfDisplay,
      ktMenuClasses,
    } = this.props;

    return (
      <>
        <button
          className="kt-header-menu-wrapper-close"
          id="kt_header_menu_mobile_close_btn"
        >
          <i className="la la-close" />
        </button>
        <div
          className="kt-header-menu-wrapper"
          id="kt_header_menu_wrapper"
          ref={this.offCanvasCommonRef}
        >
          {disabledAsideSelfDisplay && (
            <div className="kt-header-logo">
              <Link to="/">
                <img alt="logo" src={this.getHeaderLogo()} />
              </Link>
            </div>
          )}

          <div
            id="kt_header_menu"
            className={`kt-header-menu kt-header-menu-mobile ${ktMenuClasses}`}
            ref={this.ktMenuCommonRef}
          >
            <div className="homepage_companyname">
              {this.state.companyname?.customerName !== "" &&
              this.state.companyname?.customerName !== undefined
                ? this.state.companyname?.customerName
                : ""}
            </div>
            {this.state.subscriptionmsg ? (
              <div>
                <Alert severity="warning" className="font-12">
                  {this.state.subscriptionmsg}
                </Alert>
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  config: store.builder.layoutConfig,
  menuConfig: store.builder.menuConfig,
  ktMenuClasses: builder.selectors.getClasses(store, {
    path: "header_menu",
    toString: true,
  }),
  headerSelfSkin: builder.selectors.getConfig(store, "header.self.skin"),
  disabledAsideSelfDisplay:
    objectPath.get(store.builder.layoutConfig, "aside.self.display") === false,
});

// ✅ Export using custom withRouter
export default withRouter(connect(mapStateToProps)(HMenu));
